import React, {useCallback, useEffect, useState} from 'react';


const RadioGroupSel= ({name, items, callBack, defaultValue}) => {
    const [options, setoptions] = useState([]);
    const [selected, setselected] = useState(defaultValue);

    const changeSelect = useCallback(
        (e) => {
            if (e.target.value) {
                setselected(e.target.value);
                const valToSend = {[name]: e.target.value};
                callBack(valToSend);
            }
        },
        [callBack, name],
    );

    useEffect(() => {
        const optionsRes = items.enum.reduce(
            (res, elem, idx) => [...res, {val: elem, desc: items.enumDesc[idx]}],
            [],
        );
        setoptions(optionsRes);
    }, [items]);

    return (
        <fieldset className="group-layout">
            {options.map((elem, idx) => (
                <div key={idx}>
                    <input
                        type="radio"
                        id={`r_${idx}`}
                        name="radio"
                        value={elem.val}
                        onChange={changeSelect}
                        checked={elem.val === selected}
                    />
                    <label htmlFor={`r_${idx}`}>{elem.desc}</label>
                </div>
            ))}
        </fieldset>
    );
};

export default RadioGroupSel;
